import { Text } from 'components/text/Text';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';
import { colors } from 'styles/colors';
import { Breakpoints } from 'logic/hooks/use-breakpoints';
import { CustomIcon } from 'components/custom-icon/CustomIcon';
import { LIGHTBULB_ICON } from 'assets/icons/icons';
import { translate } from 'logic/translations/translations.service';
import { ITranslation } from 'src/pages-all/static/tos/TOSBody';
import { Button, Modal } from 'antd';
import Paragraph from 'antd/lib/typography/Paragraph';
import { InterpolateOptions } from 'i18n-js';

export interface InstructionBoxProps {
  heading: React.ReactNode;
  paragraphsTranslationKeys: ITranslation;
  interpolateOptions?: InterpolateOptions;
  top?: number;
}

export const InstructionBox: React.FC<InstructionBoxProps> = ({
  heading,
  paragraphsTranslationKeys,
  interpolateOptions,
  top,
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const handleOpenModal = useCallback(() => setModalVisible(true), []);
  const handleCloseModal = useCallback(() => setModalVisible(false), []);
  const renderContent = useCallback(
    () => (
      <>
        <Row>
          <CustomIcon height={28} src={LIGHTBULB_ICON} />
        </Row>
        <Row>
          <Text strong color="grey">
            {heading}
          </Text>
        </Row>
        {Object.entries(paragraphsTranslationKeys).map(([translationKey, translationValue]) => (
          <Paragraph key={translationKey}>
            {translate(translationValue, interpolateOptions)
              .split('\n')
              .map((line, index) => (
                <div key={index}>
                  {line}
                  <br />
                </div>
              ))}
          </Paragraph>
        ))}
      </>
    ),
    [heading, paragraphsTranslationKeys, interpolateOptions]
  );

  return (
    <>
      <InfoBox top={top}>{renderContent()}</InfoBox>
      <InfoBoxModal>
        <BulbButton type="dashed" shape="circle" onClick={handleOpenModal}>
          <CustomIcon height={20} src={LIGHTBULB_ICON} />
        </BulbButton>
        <Modal
          visible={modalVisible}
          onCancel={handleCloseModal}
          maskClosable
          footer={null}
          centered
        >
          {renderContent()}
        </Modal>
      </InfoBoxModal>
    </>
  );
};

const InfoBoxModal = styled.div`
  display: block;

  @media (${Breakpoints.minDesktop}) {
    display: none;
  }
`;

const BulbButton = styled(Button)`
  margin-bottom: 20px;
  margin-left: 20px;
`;

const InfoBox = styled.div<{ top?: number }>`
  display: none;

  @media (${Breakpoints.minDesktop}) {
    display: block;
    position: absolute;
    top: ${({ top = 60 }) => top}px;
    left: 115%;
    background-color: ${colors.white};
    width: 260px;
    padding: 20px;
    border: 1px solid ${colors.gray4};
    border-radius: 4px;
  }
`;

const Row = styled.div`
  margin-bottom: 14px;
`;
